import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  compose,
  setDisplayName,
} from 'recompose';
import moment from 'moment';
import {
  get,
  orderBy,
} from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import ArrowIcon from '@material-ui/icons/ArrowRightAlt';

import { shortenDuration } from 'helpers/utils';
import {
  injectIntl,
  SmartDialog,
} from 'components';

const styles = () => ({
  descriptionCell: {
    color: 'black',
    fontSize: '0.825rem',
  },
  descriptionCol: {
    paddingLeft: 0,
    paddingRight: 10,
  },
  timeCell: {
    color: 'black',
    fontSize: '0.75rem',
  },
  timeCol: {
    minWidth: 100,
    paddingRight: 0,
  },
  upArrow: {
    color: 'green',
    transform: 'rotate(-90deg)',
    verticalAlign: 'bottom',
  },
  downArrow: {
    color: 'red',
    transform: 'rotate(90deg)',
    verticalAlign: 'bottom',
  },
});

class NotificationsDialog extends Component {
  static propTypes = {
    classes: PropTypes.shape({}).isRequired,
    notifications: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
      }),
    ),
    open: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,

    formatMessage: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  static defaultProps = {
    notifications: [],
  };

  state = {
    order: 'createdAt',
    direction: 'desc',
  };

  render() {
    const {
      classes,
      notifications,
      open,
      title,
      formatMessage,
      onClose,
    } = this.props;
    const { order, direction } = this.state;
    const sortedNotifications =
      orderBy(notifications, order, direction).filter(({ storeItem }) => storeItem);
    const subItem = notification => get(notification, 'storeItem.productData.subname');
    return (
      <SmartDialog
        maxWidth="md"
        onClose={onClose}
        open={open}
        title={title}
        closeButtonOnTop
      >
        <div className="notifications-dialog">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell className={classes.descriptionCol}>
                  <Tooltip
                    title="Sort"
                    enterDelay={300}
                  >
                    <TableSortLabel
                      active={order === 'action'}
                      direction={order === 'action' ? direction : 'asc'}
                      onClick={() =>
                        this.setState({
                          order: 'action',
                          direction: order === 'action'
                            ? (direction === 'asc' ? 'desc' : 'asc')
                            : 'asc',
                        })
                      }
                      hideSortIcon
                    >
                      {formatMessage('Action')}
                    </TableSortLabel>
                  </Tooltip>
                </TableCell>
                <TableCell
                  className={classes.timeCol}
                  padding="none"
                  style={{ textAlign: 'center' }}
                >
                  <Tooltip
                    title="Sort"
                    enterDelay={300}
                  >
                    <TableSortLabel
                      active={order === 'createdAt'}
                      direction={order === 'createdAt' ? direction : 'asc'}
                      onClick={() =>
                        this.setState({
                          order: 'createdAt',
                          direction: order === 'createdAt'
                            ? (direction === 'asc' ? 'desc' : 'asc')
                            : 'asc',
                        })
                      }
                      hideSortIcon
                    >
                      {formatMessage('Time')}
                    </TableSortLabel>
                  </Tooltip>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sortedNotifications.map((notification, index) => (
                <TableRow key={index}>
                  <TableCell
                    className={classes.descriptionCol}
                    component="th"
                    scope="row"
                  >
                    <Typography
                      classes={{ body1: classes.descriptionCell }}
                      variant="body1"
                    >
                      <strong style={{ color: 'red' }}>
                        {formatMessage(notification.action)}:&nbsp;
                      </strong>
                      <strong>{get(notification, 'storeItem.productData.name')}</strong>
                      <strong>{subItem(notification) && `, ${subItem(notification)} `}</strong>
                      <span style={{ color: 'gray' }}>({get(notification, 'storeItem.productData.category')})</span>
                      {notification.storeItem.packrows.map((packrow, i) => {
                        let priceDelta = null;
                        if (notification.action === 'price change' && notification.changeData && notification.changeData.packrowIndex === i) {
                          if (Number(notification.changeData.from) === 0) {
                            priceDelta = '';
                          } else {
                            priceDelta = (notification.changeData.to -
                              notification.changeData.from) / notification.changeData.from;
                          }
                        }
                        return (
                          <Fragment key={`${i} ${packrow.count} ${packrow.uom} ${packrow.pack}`}>
                            <span>
                              {`, ${packrow.count} ${packrow.uom} ${packrow.pack}`}
                            </span>
                            <span>
                              {notification.action === 'qty update' && notification.changeData && notification.changeData.packrowIndex === i ? (
                                <Fragment>
                                  <strong>
                                    , qty&nbsp;
                                  </strong>
                                  <Fragment>
                                    <strong>
                                      <span>
                                        {Math.floor(parseFloat(notification.changeData.from)
                                          .toFixed(0))}
                                      </span>&nbsp;
                                    </strong>
                                    <ArrowIcon style={{
                                      paddingTop: 3,
                                      verticalAlign: 'bottom',
                                    }} />
                                    &nbsp;
                                    <span style={{ color: 'red', fontWeight: 'bold' }}>
                                      {Math.floor(parseFloat(notification.changeData.to)
                                        .toFixed(0))}
                                    </span>
                                  </Fragment>
                                </Fragment>
                              ) : (
                                <Fragment>
                                  , qty&nbsp;
                                  {
                                    Math.floor(packrow.availableQuantity)
                                  }
                                </Fragment>
                              )}
                            </span>
                            <span>
                              ,&nbsp;
                              {notification.action === 'price change' && notification.changeData && notification.changeData.packrowIndex === i ? (
                                <Fragment>
                                  <span>
                                    <strong>
                                      ${Math.floor(parseFloat(notification.changeData.from)
                                        .toFixed(0))}
                                    </strong>
                                  </span>&nbsp;
                                  <ArrowIcon style={{
                                    paddingTop: 3,
                                    verticalAlign: 'bottom',
                                  }} />&nbsp;
                                  <span style={{ color: 'red' }}>
                                    ${Math.floor(parseFloat(notification.changeData.to).toFixed(0))}
                                  </span>&nbsp;&nbsp;
                                  {priceDelta &&
                                    <span style={priceDelta !== 0 ? { color: priceDelta < 0 ? 'red' : 'green' } : {}}>
                                      {priceDelta < 0 ? '-' : (priceDelta !== 0 && '+')}
                                      {typeof priceDelta === 'string' ? priceDelta : `${(priceDelta * 100).toFixed(2)}%`}
                                      {priceDelta !== 0 &&
                                        <ArrowIcon className={priceDelta < 0 ?
                                          classes.downArrow : classes.upArrow} />
                                      }
                                    </span>
                                  }
                                </Fragment>
                              ) : (
                                `$${Math.floor(Number(packrow.price || 0).toFixed(0))}`
                              )}
                            </span>
                          </Fragment>
                        );
                      })}
                    </Typography>
                  </TableCell>
                  <TableCell
                    classes={{ root: classes.timeCell }}
                    numeric
                    padding="none"
                  >
                    {shortenDuration(moment(notification.createdAt).fromNow())}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </SmartDialog>
    );
  }
}

export default compose(
  setDisplayName('NotificationsDialog'),
  withStyles(styles),
  injectIntl,
)(NotificationsDialog);
